module.exports = __webpack_public_path__ + "img/banner-login-1.0b49a7d0.png";